import { jsx as e } from "react/jsx-runtime";
import { forwardRef as y, isValidElement as C } from "react";
import { u as b, l as p, F as R } from "../../../floating-ui.react-CreHqeI3.js";
import k from "../hooks/usePopoverContext.js";
import T from "../hooks/usePopoverTransition.js";
import { MarketTheme as E } from "../../MarketTheme/MarketTheme.js";
const I = y((f, m) => {
  const {
    children: o,
    style: u,
    initialFocus: n,
    ...r
  } = f, {
    container: v = "div",
    context: a,
    disableFocusManager: i,
    layerMode: s,
    portalRootId: g,
    ...t
  } = k(), l = C(o) ? o.ref : void 0, c = [t.refs.setFloating, m];
  l && c.push(l);
  const x = b(c), { status: h, visible: F, onTransitionEnd: P } = T();
  if (!F)
    return null;
  const M = t.getFloatingProps(r), d = /* @__PURE__ */ e(
    v,
    {
      ref: x,
      "data-placement": t.placement,
      "data-status": h.current,
      popover: s === "native" ? "manual" : void 0,
      style: { ...t.floatingStyles, zIndex: 1e3, ...u },
      onTransitionEnd: P,
      ...M,
      ...r,
      children: o
    }
  );
  return s === "native" ? /* @__PURE__ */ e(
    p,
    {
      initialFocus: n,
      context: a,
      disabled: i,
      modal: !1,
      children: d
    }
  ) : /* @__PURE__ */ e(R, { id: g, children: /* @__PURE__ */ e(
    p,
    {
      initialFocus: n,
      context: a,
      disabled: i,
      modal: !1,
      children: /* @__PURE__ */ e(E, { children: d })
    }
  ) });
});
I.displayName = "MarketPopoverContent";
export {
  I as MarketPopoverContent
};
